import { FC } from 'react';
import { Control, FieldErrors } from 'react-hook-form';

import RadioGroup from '~/ui/components/inputs/RadioGroup';
import { SORT_BY_OPTIONS } from '../../constants';
import { IFormValues } from '../../types';

interface IProps {
  control: Control<IFormValues>;
  errors: FieldErrors;
}

const SortPastVisits: FC<IProps> = ({ control, errors }) => (
  <RadioGroup
    control={control}
    name="sortBy"
    errors={errors}
    options={SORT_BY_OPTIONS}
    size="small"
    orientation="vertical"
  />
);

export default SortPastVisits;
